module.exports = __webpack_public_path__ + "img/9.0573c00b.png";